import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filtersActions';

let initState = {
  count: 0,
  fields: null,
  search: null,
  typeList: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsCustomers]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchCustomers]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.changeTypeListCustomers]: (state, action) => {
      return {
        ...state,
        typeList: action.payload,
      };
    },
    [filtersActions.countFiltersCustomers]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersCustomers]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
